"use client";

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu } from 'lucide-react';
import Image from 'next/image';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#projects', label: 'Projects' },
    { href: '#services', label: 'Services' },
    { href: '#knowledge-center', label: 'Knowledge' },
    { href: '#connect', label: 'Connect' },
    { href: '#faq', label: 'FAQ' },
  ];

  const NavItems = () => (
    <>
      {navLinks.map((link) => (
        <Link key={link.href} href={link.href} passHref>
          <Button onClick={() => setIsMenuOpen(false)} variant="ghost" className="text-sm font-medium text-foreground hover:bg-primary/10 w-full justify-start md:w-auto md:justify-center">
            {link.label}
          </Button>
        </Link>
      ))}
    </>
  );

  return (
    <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'bg-card/80 backdrop-blur-sm shadow-md' : 'bg-transparent'}`}>
      <div className="container mx-auto flex h-20 items-center justify-between px-4 sm:px-6">
        <Link href="/" className="flex items-center gap-2" passHref>
            <Image src="/icontrans.png" alt="CryptoSI Icon" width={32} height={32} className="h-8 w-8" />
            <span className="text-lg sm:text-xl font-bold text-primary font-headline">CryptoSI.org</span>
        </Link>
        <nav className="hidden md:flex items-center gap-2">
          <NavItems />
        </nav>
        <div className="md:hidden">
          <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon">
                <Menu className="h-6 w-6" />
                <span className="sr-only">Toggle navigation menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right">
              <div className="flex flex-col items-start gap-4 p-4">
                <Link href="/" className="flex items-center gap-2 mb-4" passHref>
                  <Image src="/icontrans.png" alt="CryptoSI Icon" width={32} height={32} className="h-8 w-8" />
                  <span className="text-xl font-bold text-primary font-headline">CryptoSI.org</span>
                </Link>
                <div className="flex flex-col w-full gap-2">
                    <NavItems />
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
